/* eslint-disable default-param-last */
import { Vector3 } from 'three';
import { DEFAULT_EMPTY_TEXTURE } from '../../utils/constants';
import { serializeTexture } from '../../utils/export/serializeTexture';
import Entity, { IEntity } from '../abstract/Entity';
import { IAsset } from './AssetModel';
import { IAttribute } from './AttributeModel';
import { IObject } from './ObjectModel';

export interface IModel2D extends IEntity {
  id: number;
  name: string;
  filePath: string;
  fileFormat: string;
  fileSize: number;
  dimensions: { length: number; depth: number };
  position: Vector3;
  rotation: number;
  texture?: any;
  object: IObject;
}

class Model2DModel extends Entity implements IModel2D {
  id: number;
  name: string;
  filePath: string;
  fileFormat: string;
  fileSize: number;
  dimensions: { length: number; depth: number };
  position: Vector3;
  rotation: number;
  texture?: any;
  object: IObject;
  asset: IAsset | undefined;

  constructor(
    id: number,
    name: string,
    filePath: string,
    fileFormat: string,
    fileSize: number,
    length: number,
    depth: number,
    object: IObject,
    position: Vector3 = new Vector3(0, 0, 0),
    rotation: number = 0,
    texture?: any | null,
    attributes: Array<IAttribute> = [],
    uuid: string | undefined = undefined,
  ) {
    super(attributes);
    if (uuid) {
      this.uuid = uuid;
    }
    this.id = id;
    this.name = name;
    this.filePath = filePath;
    this.fileFormat = fileFormat;
    this.fileSize = fileSize;
    this.dimensions = { length, depth };
    this.object = object;
    this.position = position;
    this.rotation = rotation;
    this.texture = texture ?? DEFAULT_EMPTY_TEXTURE;
  }

  getId(): number {
    return this.id;
  }
  setId(value: number): void {
    this.id = value;
  }

  getName(): string {
    return this.name;
  }
  setName(value: string): void {
    this.name = value;
  }

  getFilePath(): string {
    return this.filePath;
  }
  setFilePath(value: string): void {
    this.filePath = value;
  }

  getFileFormat(): string {
    return this.fileFormat;
  }
  setFileFormat(value: string): void {
    this.fileFormat = value;
  }

  getFileSize(): number {
    return this.fileSize;
  }
  setFileSize(value: number): void {
    this.fileSize = value;
  }

  getDimensions(): { length: number; depth: number } {
    return this.dimensions;
  }
  setDimensions(value: { length: number; depth: number }): void {
    this.dimensions = value;
  }

  getPosition(): Vector3 {
    return this.position;
  }
  setPosition(value: Vector3): void {
    this.position = value;
  }

  getRotation(): number {
    return this.rotation;
  }
  setRotation(value: number): void {
    this.rotation = value;
  }

  getTexture(): any | undefined {
    return this.texture;
  }
  setTexture(value: any | null | undefined): void {
    this.texture = value ?? undefined;
  }

  getObject(): IObject {
    return this.object;
  }
  setObject(value: IObject): void {
    this.object = value;
  }

  updatePosition(newPosition: Vector3) {
    this.position = newPosition;
  }
  updateDimensions(length: number, depth: number) {
    this.dimensions = { length, depth };
  }

  toJSON() {
    return {
      ...super.toJSON(),
      id: this.id,
      name: this.name,
      filePath: this.filePath,
      fileFormat: this.fileFormat,
      fileSize: this.fileSize,
      dimensions: this.dimensions,
      object: this.object,
      position: {
        x: this.position.x,
        y: this.position.y,
        z: this.position.z,
      },
      rotation: this.rotation,
      texture: serializeTexture(this.texture),
    };
  }
}

export default Model2DModel;
